import { render, staticRenderFns } from "./Sitios.vue?vue&type=template&id=56d5acff&"
import script from "./Sitios.vue?vue&type=script&lang=js&"
export * from "./Sitios.vue?vue&type=script&lang=js&"
import style0 from "./Sitios.vue?vue&type=style&index=0&id=56d5acff&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports